module.exports = __webpack_public_path__ + "static/media/bike1.4455c6c8.png";